import { MenuItem } from '@src/common/components/Menu';
import type { OrderListing } from '@src/orders/domain/OrderList';
import { OrderActions } from '@src/orders/domain/OrderList';
import { Navigation } from '@src/routing/Navigation';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

type Props = {
  order: OrderListing;
};
export const ViewOrderAction = ({ order }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const navigateToForm = () => {
    navigate(Navigation.orders.view.url(order.id));
  };

  return (
    order.canDo(OrderActions.VIEW) && (
      <MenuItem key={`${order.id}-view`} onClick={navigateToForm}>
        {t('view')}
      </MenuItem>
    )
  );
};
